import React from 'react';
import { useTranslation } from 'react-i18next';
import './Payment.css'; // Asegúrate de crear este archivo para los estilos


const CancelPayment = () => {
  const { t } = useTranslation();

  return (
    <div className="cancel-container">
      <div className="payment-card">
        <div className="payment-card-body">
          <h1 className="payment-card-title">{t('cancelPaymentTitle')}</h1>
          <p className="payment-card-text">
          {t('cancelPaymentBody')}
          </p>
          <p>{t('cancelPaymentFooter')}</p>
          <a href="/plans" className="btn btn-basic mt-4">
          {t('cancelPaymentPlans')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CancelPayment;
